export default __webpack_public_path__ + "static/media/1.7bf21c81.jpg";